import React, { useEffect, useState } from "react";
import {
  ErrorMessage,
  MainImageBackground,
  PcPlusContent,
} from "src/components";

import styles from "./styles.module.scss";
import { UIButton, UICard } from "src/components/uIKit";
import { useAppDispatch, useAppSelector } from "src/hooks/useRedux";
import { images } from "src/assets/images/images";
import {
  ServiceIncludesList,
} from "src/utils/types";
import { API_RESULT, ROUTES, URL_SOURCE_TYPE } from "src/utils/enums";
import { useNavigate } from "react-router-dom";
import { getCountries } from "src/redux/slices/userSlice/UserApi";
import { useCustomNavigate } from "src/hooks/useCustomNavigate";
import ScreenReaderText from "src/components/accessibilityKit/screenReaderText/ScreenReaderText";
import { getUrlParams } from "src/utils/utils";
import { useRouteParams } from "src/hooks/useRouteParams";
// import { useLogAnalytics } from "src/hooks/useLogAnalytics";
const PcPlusScreen: React.FC = () => {
  const { strings } = useAppSelector((state) => state.app);
  const { taxRefundInfoResStatus, countriesResStatus } = useAppSelector(
    (state) => state.user
  );
  const { navigateTo } = useCustomNavigate();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [serviceIncludesList, setServiceIncludesList] = useState<
    ServiceIncludesList[]
  >([]);
  const img = images.mainImage;
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const { currentSource } = useRouteParams();
  // useLogAnalytics({ pc_plus: true });

  useEffect(() => {
    if (strings) {
      setServiceIncludesList([
        {
          image: images.pcPlus1,
          imageWidth: 38,
          imageHeight: 30,
          title: strings.t_pc_plus_what_the_service_includes_list_item_title_1,
          subTitle:
            strings.t_pc_plus_what_the_service_includes_list_item_sub_title_1,
        },
        {
          image: images.pcPlus2,
          imageWidth: 27,
          imageHeight: 38,
          title: strings.t_pc_plus_what_the_service_includes_list_item_title_2,
          subTitle:
            strings.t_pc_plus_what_the_service_includes_list_item_sub_title_2,
          // options: [
          //   strings.t_pc_plus_what_the_service_includes_list_item_sub_title_2_option_1,
          //   strings.t_pc_plus_what_the_service_includes_list_item_sub_title_2_option_2,
          //   strings.t_pc_plus_what_the_service_includes_list_item_sub_title_2_option_3,
          // ],
        },
        {
          image: images.pcPlus3,
          imageWidth: 25,
          imageHeight: 42,
          title: strings.t_pc_plus_what_the_service_includes_list_item_title_3,
          subTitle:
            strings.t_pc_plus_what_the_service_includes_list_item_sub_title_3,
        },
      ]);
    }
  }, [strings]);

 

  const onSubmit = () => {
    switch (currentSource) {
      case URL_SOURCE_TYPE.REP_MANUAL:
      case URL_SOURCE_TYPE.SMS_SHARE:
      case URL_SOURCE_TYPE.CAMPAIGN:
      case URL_SOURCE_TYPE.MARKETING:
      case URL_SOURCE_TYPE.SMS:
      case URL_SOURCE_TYPE.APP:
        // navigate to login choose policy
        navigate(
          `/${currentSource}/${ROUTES.LOGIN}/${ROUTES.LOGIN_DETAILS}?${getUrlParams()}`
        );
        // if (fXEligibilityData?.policyDetails?.length > 1) {
        //   navigate(
        //     `/${currentSource}/${ROUTES.LOGIN}/${ROUTES.LOGIN_CHOOSE_POLICY}`
        //   );
        // } else {
        //   navigate(`/${currentSource}/${ROUTES.UPDATE_CONTACT_DETAILS}`);
        // }
        break;
      default:
        navigate(`/${currentSource}/${ROUTES.UPDATE_CONTACT_DETAILS}`);
        break;
    }
  };
  useEffect(() => {
    if (taxRefundInfoResStatus === API_RESULT.SUCCEEDED) {
      setShowErrorMessage(false);
      //
      dispatch(getCountries({}));
    } else if (taxRefundInfoResStatus === API_RESULT.FAILED) {
      setShowErrorMessage(true);
    }
  }, [taxRefundInfoResStatus]);

  useEffect(() => {
    if (countriesResStatus === API_RESULT.SUCCEEDED) {
      navigateTo(ROUTES.SUMMARY_SCREEN);
    } else if (countriesResStatus === API_RESULT.FAILED) {
      setShowErrorMessage(true);
    }
  }, [countriesResStatus]);

  return (
    <div className={styles.container}>
      <MainImageBackground
        desktopImageSrc={images.mainImage}
        mobileImageSrc={images.mainMobile}
      />
      <UICard>
        <>
          <ScreenReaderText
            text={[
              strings.acc_t_pc_plus_title,
              strings.acc_t_pc_plus_what_the_service_includes_title,
              strings.acc_t_pc_plus_what_the_service_includes_sub_title,
            ]}
            announnceDelay={2100}
          />

          <PcPlusContent
            headerText={strings.t_pc_plus_title}
            title={strings.t_pc_plus_what_the_service_includes_title}
            subTitle={""}
            image={img}
            body={serviceIncludesList}
            footerTitle={
              strings.t_pc_plus_what_the_service_includes_footer_title
            }
            footerOptions={[
              strings.t_pc_plus_what_the_service_includes_footer_option1,
              strings.t_pc_plus_what_the_service_includes_footer_option2,
              strings.t_pc_plus_what_the_service_includes_footer_option3,
            ]}
          />

          <div className={styles.acceptButtonWrapper}>
            {showErrorMessage && (
              <>
                <ErrorMessage
                  message={strings.t_must_list_error_message}
                  ariaLabel={strings.acc_t_must_list_error_message}
                />
                <br />
              </>
            )}
            <UIButton
              tabIndex={0}
              title={strings.t_pc_plus_next_button}
              ariaLabel={strings.acc_t_pc_plus_next_button}
              onSubmit={onSubmit}
              isLoading={taxRefundInfoResStatus === API_RESULT.LOADING}
            />
          </div>
          <br />
        </>
      </UICard>
    </div>
  );
};

export default PcPlusScreen;
